import { createAsyncThunk } from '@reduxjs/toolkit';
import { isAxiosError } from 'axios';

import { loadCurrentUser, loadUserSettings } from '../../services/user';
import { buildApiUrl } from '../../utils/axiosClient';
import { UserInfo } from './slice';

export const getCurrentUser = createAsyncThunk(
  'user/getCurrentUser',
  async (): Promise<UserInfo> => {
    try {
      const user = await loadCurrentUser();
      return user || {};
    } catch (error) {
      if (isAxiosError(error)) {
        if (error.response && error.response?.status === 403) {
          return new Promise((resolve, reject) => {
            window.location.replace(buildApiUrl(process.env.REACT_APP_LOGIN_PAGE ?? ''));
          });
        }
      }
      throw error;
    }
  },
);

export const getUserSettings = createAsyncThunk(
  'user/getUserSettings',
  async (): Promise<any> => {
    try {
      const settings = await loadUserSettings();
      return settings || {};
    } catch (error) {
      console.error('Error loading user settings', error);
      throw error;
    }
  },
);
